export const PASSWORD_INPUT_TYPES = {
  PASSWORD: 'password',
  TEXT: 'text'
} as const

export type PasswordInputType = (typeof PASSWORD_INPUT_TYPES)[keyof typeof PASSWORD_INPUT_TYPES]
